import { variants, styles, TextFieldInputTheme } from '../TextFieldInputStyles.css';
import { multiVariantStyles } from './TextFieldInputVariants.css';

const TextFieldInputRedwoodTheme: TextFieldInputTheme = {
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { TextFieldInputRedwoodTheme };
